// extracted by mini-css-extract-plugin
export var dividerLine = "_87-3";
export var itemImage = "_87-9";
export var lightDivider = "_87-4";
export var modalContent = "_87-5";
export var modalContentCompact = "_87-6";
export var productCard = "_87-a";
export var productImage = "_87-b";
export var productImageCompact = "_87-7";
export var productImagePlaceholder = "_87-c";
export var productImagePlaceholderCompact = "_87-8";
export var progressBarBackground = "_87-1";
export var progressBarContainer = "_87-0";
export var progressBarFill = "_87-2";